<mat-card class="card-table has-progress-bar" *ngIf="patientDataService.patient$ | async as patient">
  <mat-progress-bar [mode]="(loading$ | async) ? 'indeterminate' : 'determinate'"></mat-progress-bar>
  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <mmx-authorization-status-icon
      *ngIf="appointment"
      class="mr-3"
      [patient]="patient"
      [appointment]="appointment"
      (authorizationSaved)="data.appointmentUpdated$.next()"
    ></mmx-authorization-status-icon>
    <span>{{ 'patient-details.authorization-card.title' | translate }}</span>
    <div fxFlex></div>
    <div>
      <ng-container *ngIf="whyCantPullAuths$ | async as whyCantPullAuths">
        <span
          [matTooltip]="whyCantPullAuths.tooltip"
          class="pr-3 regular-text"
        >
          {{ whyCantPullAuths.text }}
        </span>
      </ng-container>
      <button
        *ngIf="appointment?.account"
        mat-stroked-button
        class="mr-2"
        (click)="openAuthorizationHistoryDialog(appointment.account)"
      >
        <mat-icon>history</mat-icon>
        <span>{{ 'patient-details.authorization-card.button-history' | translate }}</span>
      </button>
      <mmx-appointment-portal-menu
        *ngIf="hasPortals"
        type="authorization"
        [appointment]="appointment"
      >
      </mmx-appointment-portal-menu>
      <button
        *appHasPermission="'prior-authorization.pull'"
        mat-stroked-button
        class="mr-2"
        (click)="openPullServiceReviewsDialog(patient)"
        [disabled]="(whyCantPullAuths$ | async) !== null"
      >
        <mat-icon>download</mat-icon>
        <span>{{ 'patient-details.authorization-card.button-pull' | translate }}</span>
      </button>
      <button
        *appHasPermission="Permission.AUTHORIZATION_CREATE"
        mat-stroked-button
        (click)="openAuthorizationDialog()"
      >
        <mat-icon>add</mat-icon>
        <span>{{ 'patient-details.authorization-card.button-add' | translate }}</span>
      </button>
    </div>
  </mat-card-title>
  <mat-card-content fxLayout="column">
    <ng-container *ngIf="(loading$ | async) === false; else loadingEl">
      <ng-container *ngIf="authorizations$ | async as authorizations">
        <mmx-authorization-table
          [authorizations]="authorizations"
          [clinic]="clinic"
          [appointment]="appointment"
          [insurances]="patientDataService.insurances$ | async"
          [canPullAuthStatus]="canPullPriorAuthorization$ | async"
          (filterActiveChange)="showFilteredAuthorizations$.next($event)"
          [showProcedureQuantity]="clinic?.modulesPreferences?.showAuthorizationProcedureQuantity"
          [showRemaining]="clinic?.modulesPreferences?.calcAuthProcedureQtyFromAppts"
          (deleteAuthorization)="deleteAuthorization($event)"
          (saveAuthorization)="save($event)"
          (editAuthorization)="openAuthorizationDialog($event)"
          (pullAuthorizationStatus)="pullAuthStatus($event)"
          (cancelPullAuthorizationStatus)="cancelPullAuthStatus($event)"
          ></mmx-authorization-table>
      </ng-container>

      <div *ngIf="numberOfHiddenAuths$ | async as numberOfHiddenAuths" class="text-center py-5">
        <button
          mat-stroked-button
          (click)="showAllAuthorizations$.next(true)"
          [matTooltip]="'patient-details.authorization-card.button-show-all-tooltip' | translate: { count: numberOfHiddenAuths }"
        >
          {{ 'patient-details.authorization-card.button-show-all' | translate: { count: numberOfHiddenAuths } }}
        </button>
      </div>
    </ng-container>
  </mat-card-content>



  <ng-template #loadingEl>
    <div class="text-center mmx-card-padding mt-5 mb-5">
      {{ 'patient-details.authorization-card.loading' | translate }}
    </div>
  </ng-template>
</mat-card>
